module.exports = __webpack_public_path__ + "img/eseminar-d.67e4950.webp";